import { Stack } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useController } from 'react-hook-form';
import { FormLabel, FormTextFieldProps } from 'src/components';
import { DateTrigger } from 'src/components/DateTrigger';
import { SidePanelRow } from 'src/components/SidePanelRow';

export const ProjectDateTriggerField = ({
  field,
  disabled,
}: {
  field: FormTextFieldProps;
  disabled?: boolean;
}) => {
  const { label, name, value } = field;
  const { field: controllerField } = useController<Record<string, Dayjs | null>>({ name });
  const fallbackValue: Dayjs | null =
    typeof value === 'string' ? dayjs(value) : (value ?? null);

  return (
    <SidePanelRow key={label}>
      <FormLabel label={label} />
      <Stack direction="row" alignItems="center" width="100%" gap={1}>
        <DateTrigger
          label={label ?? ''}
          value={controllerField.value ?? fallbackValue}
          onChange={controllerField.onChange}
          disabled={disabled}
          sx={{ width: '100%' }}
        />
      </Stack>
    </SidePanelRow>
  );
};
